export const ROOT = '/';
export const IMAGE_TEMPLATE = `${ROOT}image-template/:submissionId?`;
